import { useEffect, useRef } from "react";
import { resetElementHeight } from "./helpers";

function useDynamicTextAreaHeight(readOnly, value) {
  const textareaRef = useRef()
  const textContainerRef = useRef()

  useEffect(() => {

    if (!readOnly) {
      textareaRef.current.onkeydown = (evt) => {
        // console.log('event key', evt.key, evt.keyCode)
        if([16, 17].includes(evt.keyCode)) {
          // evt.stopPropagation()
          // evt.preventDefault()
          return false
        }
        resetTextHeights()
      }
      textareaRef.current.oninput = setTextHeights
      resetTextHeights()
      setTextHeights()
    } else {
      resetElementHeight(textContainerRef.current)
    }
  }, [value, readOnly])

  function resetTextHeights() {
    textareaRef.current.style.height = 'auto'
    textContainerRef.current.style.minHeight = `${textareaRef.current.scrollHeight + 5}px`
  }

  function setTextHeights() {
    if(!textareaRef.current.style)return
    textContainerRef.current.style.minHeight = `${textareaRef.current.scrollHeight + 5}px`
    textareaRef.current.style.height = `${textareaRef.current.scrollHeight + 5}px`
  }

  return [textContainerRef, textareaRef]
}

export { useDynamicTextAreaHeight }